import { render, staticRenderFns } from "./edit-subtype.vue?vue&type=template&id=c6f095e8&"
import script from "./edit-subtype.vue?vue&type=script&lang=js&"
export * from "./edit-subtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports